import ChangePassword from "./changePasswordContainer";
export default ChangePassword;
